import React, { useCallback } from 'react';
import * as styles from './style.module.scss';

import { Formik, Form } from 'formik';
import { Link } from 'gatsby';

import Input from 'components/UI/InputFormik';
import Checkbox from 'components/UI/Checkbox';
import validationSchema from './validationSchema';

const RegistrationForm = ({ onChange }) => {
  const onChangeHandler = useCallback(
    (values, validateForm) => {
      setTimeout(async () => {
        const errors = await validateForm();
        const isValid = Object.keys(errors).length === 0;

        onChange({
          ...values,
          isValid,
        });
      }, 100);
    },
    [onChange]
  );

  return (
    <Formik
      initialValues={{
        name: '',
        companyName: '',
        phone: '',
        email: '',
        accept: false,
      }}
      validationSchema={validationSchema}
      validateOnMount
    >
      {({ validateForm, values }) => {
        return (
          <Form
            noValidate
            onChange={() => {
              onChangeHandler(values, validateForm);
            }}
          >
            <ul className={styles.form_inputs}>
              <li>
                <Input name="name" type="text" placeholder="Name" />
              </li>
              <li>
                <Input
                  name="companyName"
                  type="text"
                  placeholder="Company name"
                />
              </li>
              <li>
                <Input name="phone" type="tel" placeholder="Phone" />
              </li>
              <li>
                <Input name="email" type="email" placeholder="Email" />
              </li>
            </ul>

            <div>
              <Checkbox name="accept">
                I agree with
                <Link to="#" className={'cr-link cr-main'}>
                  Terms & Conditions.
                </Link>
              </Checkbox>
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

export default RegistrationForm;
